// extracted by mini-css-extract-plugin
export default {"panelList":"PanelList_panelList__L1yRK","headline":"PanelList_headline__tYV-f","complianceCode":"PanelList_complianceCode__x767s"};